<template>
    <div class="prepare-for-charge">
        <div class="container">
            <h1>{{ $t('m.preparingTitle') }}</h1>
            <h2>{{ subtitle || $t('m.preparingSubtitle') }}</h2>
            <LoadingIcon class="loading-icon" />
        </div>
    </div>
</template>
<script>
import LoadingIcon from "@/components/icons/LoadingIcon.vue";

export default {
    components: {
        LoadingIcon
    },
    name: "PreparingCharger",
    props: {
        subtitle: {
            type: String,
            default: ""
        }
    },
    mounted() {
        // 禁止上下左右滚动
        document.body.style.overflow = 'hidden';
        // 阻止触摸事件的默认行为
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
    },
    beforeDestroy() {
        // 恢复
        document.body.style.overflow = '';
        // 移除触摸事件监听器
        document.removeEventListener('touchmove', this.preventScroll);
    },
    methods: {
        preventScroll(event) {
            event.preventDefault();
        }
    }
}
</script>

<style lang="scss">
    .prepare-for-charge {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 9999;

        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        h1 {
            margin: 0;
            font-family: Sarala;
            font-size: 26px;
            font-weight: 700;
            line-height: 31.2px;
            margin-top: 20px;
            margin-bottom: 15px;
            width: 343px;
        }

        h2 {
            margin: 0;
            margin-bottom: 54px;
            width: 283px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20.16px;
            color: #333333;
            text-align: center;
        }
    }
</style>
